import validate from "/opt/teamcity/buildAgent/work/984757540e73c1d/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/opt/teamcity/buildAgent/work/984757540e73c1d/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/opt/teamcity/buildAgent/work/984757540e73c1d/app/middleware/auth.ts"),
  "hall-sort-parameter": () => import("/opt/teamcity/buildAgent/work/984757540e73c1d/app/middleware/hall-sort-parameter.ts"),
  unauthenticated: () => import("/opt/teamcity/buildAgent/work/984757540e73c1d/app/middleware/unauthenticated.ts")
}